import type * as React from "react";
import { PRODUCT } from "@mandrac/shared";
import { Card } from "@mandrac/ui";

/** Page frame of the sign-in and reset pages: product name, title, then the form. */
export function AuthShell({ title, subtitle, children }: { title: string; subtitle?: string; children: React.ReactNode }) {
  return (
    <main className="flex min-h-screen items-start justify-center bg-ground px-4 py-10 sm:py-16">
      <Card className="flex w-full max-w-md flex-col gap-5 p-5 sm:p-6">
        <div className="flex flex-col gap-1">
          <span className="label-caps text-muted">{PRODUCT.name}</span>
          <h1 className="m-0 text-28 font-extrabold">{title}</h1>
          {subtitle ? <p className="m-0 text-15 text-muted">{subtitle}</p> : null}
        </div>
        {children}
      </Card>
    </main>
  );
}
